module.exports = __webpack_public_path__ + "img/icon10.512b4fb4.svg";